// extracted by mini-css-extract-plugin
module.exports = {"root":"selection-card-body-icon_root__7O9lF","vertical":"selection-card-body-icon_vertical__mdhFV"};